<template>
  <div class="mt-5">
    <div
      ref="googleMap"
      class="google-map"
    ></div>
    <p class="pt-2">
      {{ addressToString }}
    </p>
  </div>
</template>
<script>
import GoogleMapsApiLoader from 'google-maps-api-loader'
import { ORGANISATION_MARKER_ICON_CONFIG } from '@/components/map-view/config/map-config'
export default {
  props: {
    mapConfig: {
      type: Object,
      default: ()=>{}
    },
    apiKey: {
      type: String,
      default:''
    },
    address: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      google: null,
      map: null
    }
  },
  computed: {
    addressToString(){
      return `${this.address.address_1}, ${this.address.address_2 + ', ' ? this.address.address_2 :''}
      ${this.address.town}, ${this.address.county + ', '? this.address.county + ', ' : ''}${this.address.post_code}`
    },
    marker(){
      return {
        position: this.mapConfig.center,
        id:1
      }
    }
  },
  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey
    })
    this.google = googleMapApi
    this.initializeMap()
  },
  methods: {
    initializeMap() {

      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
      new this.google.maps.Marker({
        position: this.marker.position,
        marker: this.marker,
        map: this.map,
        icon: ORGANISATION_MARKER_ICON_CONFIG
      })

    }
  }
}
</script>

<style scoped>
  .google-map {
    width: 100%;
    min-height: 400px;
  }
</style>